import React, { useMemo } from 'react';
import { generateDicebearAvatarUrl } from '../hooks/useAvatarGenerator';

interface AvatarDisplayProps {
  seed: string;
  size?: number;
  className?: string;
  alt?: string;
  rounded?: boolean;
}

/**
 * Component for displaying Dicebear avatars throughout the app
 * Can be used in headers, profiles, cards, etc.
 */
export function AvatarDisplay({ 
  seed, 
  size = 40, 
  className = '', 
  alt = 'User avatar',
  rounded = true
}: AvatarDisplayProps) {
  const avatarUrl = useMemo(() => generateDicebearAvatarUrl(seed, size), [seed, size]);

  return (
    <div 
      className={`
        ${rounded ? 'rounded-full' : 'rounded-lg'} overflow-hidden bg-muted flex-shrink-0
        ${className}
      `}
      style={{ width: size, height: size }}
    >
      <img
        src={avatarUrl}
        alt={alt}
        className="w-full h-full object-cover"
        loading="lazy"
      />
    </div>
  );
}
